import React from 'react';
import { connect } from 'react-redux';
import Request, { MEDIA_URL } from '../../request';
import { Row, Col, Tooltip, Icon, Card, Tag, Drawer, Table, Button, notification } from 'antd';
import styled from 'styled-components';
import { FaPlaneDeparture, FaFileInvoice, FaFileInvoiceDollar, FaWallet, FaGlobeAmericas, FaUniversity, FaPercentage } from 'react-icons/fa';
import ListDrawer from './list';
import InvoiceListDrawer from './invoiceList';
import moment from 'moment';
import { TableComp } from 'sz-react-utils';
import FileViewer from 'react-file-viewer';
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';

const link = {
    "Front Desk": '/desk/update-counselling',
    "Registration Desk": "/registration/fees",
    "Application Desk": "/desk/allApplication-desk/update",
    "Visa Desk": "/desk/getVisa",
    "Claim Desk": "/desk/getClaim"
}

const currencySymbols = {
    USD: "$",      // US Dollar
    EUR: "€",      // Euro
    GBP: "£",      // British Pound
    INR: "₹",      // Indian Rupee
    AUD: "A$",     // Australian Dollar
    CAD: "C$",     // Canadian Dollar
    JPY: "¥",      // Japanese Yen
    CNY: "¥",      // Chinese Yuan
    NZD: "NZ$",    // New Zealand Dollar
    CHF: "CHF",    // Swiss Franc
    SGD: "S$",     // Singapore Dollar
    HKD: "HK$",    // Hong Kong Dollar
    SEK: "kr",     // Swedish Krona
    NOK: "kr",     // Norwegian Krone
    DKK: "kr",     // Danish Krone
    ZAR: "R",      // South African Rand
    AED: "د.إ",    // UAE Dirham
    SAR: "﷼",     // Saudi Riyal
    THB: "฿",      // Thai Baht
    MYR: "RM",     // Malaysian Ringgit
    IDR: "Rp",     // Indonesian Rupiah
    KRW: "₩",      // South Korean Won
    TRY: "₺",      // Turkish Lira
    RUB: "₽",      // Russian Ruble
    BRL: "R$",     // Brazilian Real
    MXN: "$",      // Mexican Peso
    PHP: "₱",      // Philippine Peso
    PLN: "zł",     // Polish Zloty
    HUF: "Ft",     // Hungarian Forint
    CZK: "Kč",     // Czech Koruna
};


/**
 * 1. ScrollContainer: Improved scrollbar and spacing
 */
const ScrollContainer = styled.div`
  max-height: 160px; /* Slightly increased for better 3-row visibility */
  overflow-y: auto;
  margin-top: 16px;
  padding-right: 2px;
  border-radius: 4px;

  /* Modern Slim Scrollbar */
  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { 
    background: #d9d9d9; 
    border-radius: 10px;
    transition: background 0.3s ease;
  }
  &::-webkit-scrollbar-thumb:hover { background: #bfbfbf; }
`;

/**
 * 2. MetricTable: Interactive rows and floating headers
 */
const MetricTables = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* Ensures consistent column widths across cards */
  
  thead th {
    position: sticky;
    top: 0;
    background: #ffffff;
    z-index: 10;
    padding: 10px 4px;
    font-size: 11px;
    font-weight: 700;
    color: #8c8c8c; /* Slightly darker for accessibility */
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 2px solid #f0f0f0; /* Thicker border for header separation */
    text-align: right;
  }

  tbody td {
    padding: 12px 4px;
    border-bottom: 1px solid #f5f5f5;
    font-size: 13px;
    color: #595959; /* Standard AntD body text color */
    text-align: right;
    transition: all 0.2s ease; /* Smooth hover transition */
  }

  /* Specific Alignment for primary column */
  thead th:first-child, tbody td:first-child {
    text-align: left;
    color: #262626;
    font-weight: 600;
    padding-left: 8px;
    width: 40%; /* Fixed width for the country/category column */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Row Hover Effect */
  tbody tr:hover td {
    background: #f0f7ff; /* Subtle blue highlight */
    color: #1890ff;     /* Primary color text on hover */
    cursor: default;
  }
`;
const MetricTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* This is crucial for alignment */
  
  thead th {
    position: sticky;
    top: 0;
    background: #ffffff;
    z-index: 10;
    padding: 8px 2px;
    font-size: 11px;
    font-weight: 700;
    color: #8c8c8c;
    text-transform: uppercase;
    border-bottom: 2px solid #f0f0f0;
    text-align: right;
  }

  /* Give the first column more space, and equal space to metrics */
  thead th:nth-child(1) { width: 30%; text-align: left; padding-left: 8px; }
  thead th:nth-child(2) { width: 17.5%; }
  thead th:nth-child(3) { width: 17.5%; }
  thead th:nth-child(4) { width: 17.5%; }
  thead th:nth-child(5) { width: 17.5%; }

  tbody td {
    padding: 10px 2px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 12px; /* Slightly smaller font helps fit large numbers */
    color: #555;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  tbody td:first-child {
    text-align: left;
    padding-left: 8px;
    color: #262626;
    font-weight: 600;
  }
`;

/**
 * 3. IconHeader: Dynamic and clean
 */
const IconHeader = styled.div`
  display: flex;
  align-items: center;
  
  .icon-circle {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    /* We use props for dynamic colors now */
    background: ${props => props.bgColor || '#e6f7ff'}; 
    color: ${props => props.iconColor || '#1890ff'};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 14px;
    font-size: 18px;
    box-shadow: inset 0 0 0 1px rgba(0,0,0,0.05); /* Very subtle inner border */
  }

  span {
    font-size: 16px;
    font-weight: 700;
    color: #262626;
    letter-spacing: -0.02em;
  }
`;


class BranchLiabilityDrawer extends React.Component {
    state = {
        visible: true,
        loading: false,
        arr: []
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.setState({ loading: true });

        const { arr } = this.props.param;

        this.setState({
            arr: arr || [],
            loading: false
        });
    };

    onClose = () => {
        this.setState({ visible: false });

        setTimeout(() => {
            this.props.onClose();
        }, 400);
    };

    render() {

        const { arr, loading } = this.state;
        const { title, count, bgColorClass, icon } = this.props.param;

        const columns = [
            {
                title: "Student Details",
                key: "student",
                width: 220,
                render: (text, record) => (
                    <div>
                        <div style={{ fontWeight: 600, color: "#1a3353" }}>
                            {record.studentName}
                        </div>

                        <Tag>
                            ID : {record.studentVisionId}
                        </Tag>
                    </div>
                )
            },
            {
                title: "Invoice No.",
                dataIndex: "invoiceNumber",
                key: "invoiceNumber",
                width: 130
            },
            {
                title: "Claim No.",
                dataIndex: "claimNumber",
                key: "claimNumber",
                width: 170
            },
            {
                title: "University",
                dataIndex: "universityInstitutionName",
                key: "universityInstitutionName",
                width: 220
            },
            {
                title: "Course",
                dataIndex: "courseName",
                key: "courseName",
                width: 250
            },
            {
                title: "Gross Amount",
                key: "grossPaymentReceived",
                width: 150,
                render: (text, record) => (
                    <span>
                        {record.grossPaymentReceived} ({record.currency})
                    </span>
                )
            },
            {
                title: "Associate Amount",
                key: "associateAmount",
                width: 150,
                render: (text, record) => (
                    <span>{record.associateAmount} (INR)</span>
                )
            },
            {
                title: "Conversion Rate",
                dataIndex: "conversionRate",
                key: "conversionRate",
                width: 120
            },
            {
                title: "Branch",
                key: "branch",
                width: 150,
                render: (text, record) => {
                    if (record.branchDetails) {
                        return record.branchDetails.branchName;
                    }

                    if (record.branch_details) {
                        return record.branch_details.branchName;
                    }

                    return "-";
                }
            },
            {
                title: "Status",
                dataIndex: "status",
                key: "status",
                width: 120,
                render: text => (
                    <Tag color={text === "Approved" ? "green" : "orange"}>
                        {text}
                    </Tag>
                )
            },
            {
                title: "Created Date",
                dataIndex: "created_at",
                key: "created_at",
                width: 130,
                render: text =>
                    text ? moment(text).format(dateFormat) : "-"
            }
        ];

        return (
            <Drawer
                title={
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "98%"
                        }}
                    >
                        <span
                            style={{
                                display: "flex",
                                alignItems: "center"
                            }}
                        >
                            <span
                                style={{
                                    marginRight: 12,
                                    display: "flex",
                                    fontSize: 20
                                }}
                            >
                                {icon ? icon : <Icon type="profile" />}
                            </span>

                            {title}
                        </span>

                        <Tag className="count-tag">
                            {count} TOTAL
                        </Tag>
                    </div>
                }
                placement="right"
                visible={this.state.visible}
                width={1100}
                onClose={this.onClose}
                className={"dynamic-drawer " + bgColorClass}
            >
                <TableComp
                    dataSource={arr}
                    columns={columns}
                    loading={loading}
                    rowKey="_id"
                    extraProps={{
                        scroll: {
                            x: 1400
                        }
                    }}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50"]
                    }}
                />
            </Drawer>
        );
    }
}



// Liability Drawer
class LiabilityDrawer extends React.Component {
    state = {
        visible: true,
        arr: []
    }

    componentDidMount() {
        this.loadDashboardStudentList();
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 400);
    };

    loadDashboardStudentList = async () => {

        this.setState({ loading: true });
        const { arr } = this.props.param;
        this.setState({ arr, loading: false });
    };

    render() {
        const { arr, loading } = this.state;
        const { title, count, bgColorClass, icon } = this.props.param;

        // inside your DashboardStudentList class -> column array

        const column = [
            {
                title: "Student Details",
                key: "student",
                width: "15%",
                render: (text, record) => {
                    return (
                        <div className="student-info-wrapper">
                            <span style={{ fontWeight: 700, color: "#1a3353", fontSize: '15px' }}>
                                <a >
                                    {record.studentName}
                                </a>
                            </span>
                            <Tag style={{ width: 'fit-content', fontSize: '10px', borderRadius: '4px' }}>
                                ID: {record.visionId}
                            </Tag>
                        </div>
                    )

                }
            },
            {
                title: "Invoice Number",
                dataIndex: "invoiceNumber",
                key: "invoiceNumber",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "Inv. Generation Date",
                dataIndex: "invoiceGenerationDate",
                key: "invoiceGenerationDate",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{moment(text).format(dateFormat)}</span>
                    </div>
                )
            },
            {
                title: "Country",
                dataIndex: "country",
                key: "country",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "University",
                dataIndex: "college",
                key: "college",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "Invoice Amount",
                dataIndex: "invoiceAmount",
                key: "invoiceAmount",
                width: "12%",
                render: (text, record) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{record.invoiceAmount}({record.currency})</span>
                    </div>
                )
            },
            {
                title: "Conversion Rate",
                dataIndex: "conversionRate",
                key: "conversionRate",
                width: "12%",
                render: (text, record) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "Converted Amount",
                dataIndex: "commissionAmountReceived",
                key: "commissionAmountReceived",
                width: "12%",
                render: (text, record) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}{text ? '(INR)' : null}</span>
                    </div>
                )
            },
            {
                title: "Invoice Status",
                dataIndex: "invoiceClearanceStatus",
                key: "invoiceClearanceStatus",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "Inv. Clearance Date",
                dataIndex: "commissionReceivingDate",
                key: "commissionReceivingDate",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{moment(text).format(dateFormat)}</span>
                    </div>
                )
            },
        ];

        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '98%' }}>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                            {/* Render the dynamic icon here. If it's a React component, it will render. */}
                            <span style={{ marginRight: 12, display: 'flex', fontSize: '20px' }}>
                                {icon ? icon : <Icon type="profile" />}
                            </span>
                            {title}
                        </span>
                        <Tag className="count-tag">{count} TOTAL</Tag>
                    </div>
                }
                placement="right"
                onClose={this.onClose}
                visible={this.state.visible}
                width={1250}
                className={`dynamic-drawer ${bgColorClass}`}
            >
                <TableComp
                    dataSource={arr}
                    columns={column}
                    loading={loading}
                    extraProps={{ scroll: { x: 900 } }}
                    rowKey={(record, index) => index}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50"],
                    }}
                />
            </Drawer>
        );
    }
}




// Payment Received Drawer

class PaymentReceivedDrawer extends React.Component {
    state = {
        visible: true,
        arr: []
    }

    componentDidMount() {
        this.loadDashboardStudentList();
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 400);
    };

    loadDashboardStudentList = async () => {

        this.setState({ loading: true });
        const { arr } = this.props.param;
        this.setState({ arr, loading: false });
    };

    render() {
        const { arr, loading } = this.state;
        const { title, count, bgColorClass, icon } = this.props.param;

        // inside your DashboardStudentList class -> column array

        const column = [
            {
                title: "Student Details",
                key: "student",
                width: "15%",
                render: (text, record) => {
                    return (
                        <div className="student-info-wrapper">
                            <span style={{ fontWeight: 700, color: "#1a3353", fontSize: '15px' }}>
                                <a >
                                    {record.studentName}
                                </a>
                            </span>
                            <Tag style={{ width: 'fit-content', fontSize: '10px', borderRadius: '4px' }}>
                                ID: {record.visionId}
                            </Tag>
                        </div>
                    )

                }
            },
            {
                title: "Invoice Number",
                dataIndex: "invoiceNumber",
                key: "invoiceNumber",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "Inv. Generation Date",
                dataIndex: "invoiceGenerationDate",
                key: "invoiceGenerationDate",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{moment(text).format(dateFormat)}</span>
                    </div>
                )
            },
            {
                title: "Country",
                dataIndex: "country",
                key: "country",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "University",
                dataIndex: "college",
                key: "college",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "Invoice Amount",
                dataIndex: "invoiceAmount",
                key: "invoiceAmount",
                width: "12%",
                render: (text, record) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{record.invoiceAmount}({record.currency})</span>
                    </div>
                )
            },
            {
                title: "Conversion Rate",
                dataIndex: "conversionRate",
                key: "conversionRate",
                width: "12%",
                render: (text, record) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "Converted Amount",
                dataIndex: "commissionAmountReceived",
                key: "commissionAmountReceived",
                width: "12%",
                render: (text, record) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}{text ? '(INR)' : null}</span>
                    </div>
                )
            },
            {
                title: "Invoice Status",
                dataIndex: "invoiceClearanceStatus",
                key: "invoiceClearanceStatus",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "Inv. Clearance Date",
                dataIndex: "commissionReceivingDate",
                key: "commissionReceivingDate",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{moment(text).format(dateFormat)}</span>
                    </div>
                )
            },
        ];

        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '98%' }}>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                            {/* Render the dynamic icon here. If it's a React component, it will render. */}
                            <span style={{ marginRight: 12, display: 'flex', fontSize: '20px' }}>
                                {icon ? icon : <Icon type="profile" />}
                            </span>
                            {title}
                        </span>
                        <Tag className="count-tag">{count} TOTAL</Tag>
                    </div>
                }
                placement="right"
                onClose={this.onClose}
                visible={this.state.visible}
                width={1250}
                className={`dynamic-drawer ${bgColorClass}`}
            >
                <TableComp
                    dataSource={arr}
                    columns={column}
                    loading={loading}
                    extraProps={{ scroll: { x: 900 } }}
                    rowKey={(record, index) => index}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50"],
                    }}
                />
            </Drawer>
        );
    }
}

class ShowUniversityAgreement extends React.Component {
    state = {
        visible: true
    }
    componentDidMount() {
    }

    onError = () => {
        notification.error({
            message: 'File type not supported, try to download it.'
        })
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    render() {
        let { visible } = this.state
        let { record } = this.props
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            University Agreement
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}
            >
                <Card>
                    <FileViewer
                        fileType="pdf"
                        filePath={`${MEDIA_URL}${record.universityId.paymentUpload && record.universityId.paymentUpload[0] ? record.universityId.paymentUpload[0].url : null}`}
                        onError={this.onError} />
                </Card>
            </Drawer>
        )
    }
}



// Payment Received Drawer End



class ClaimCommissionDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.table1 = React.createRef()
        this.state = {
            visaApprovedData: [],
            drawer: false,
            drawerParam: {},
            performaInvoicesDetailsData: [],
            performaInvoicesDueDetailsData: [],
            paymentReceivedOverseasData: [],
            paymentReceivedDomesticData: [],
            liabilityForApBranchDetailsData: [],
            liabilityForTaxesDetailsData: [],
            invoiceDrawer: false,
            invoiceDrawerParam: {},
            paymentDrawer: false,
            paymentDrawerParam: {},
            liabilityDrawer: false,
            liabilityDrawerParam: {},
            branchLiabilityDrawer: false,
            branchLiabilityDrawerParam: {},
        };

        this.openDrawer = this.openDrawer.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
    }

    loadApis() {
        Request.getCliamDeskData().then(({ visaApprovedData, performaInvoicesDetailsData, performaInvoicesDueDetailsData, paymentReceivedOverseasData, paymentReceivedDomesticData, liabilityForTaxesDetailsData, liabilityForApBranchDetailsData }) => {
            this.setState({
                visaApprovedData: visaApprovedData || [],
                performaInvoicesDetailsData: performaInvoicesDetailsData || [],
                performaInvoicesDueDetailsData: performaInvoicesDueDetailsData || [],
                paymentReceivedOverseasData: paymentReceivedOverseasData || [],
                paymentReceivedDomesticData: paymentReceivedDomesticData || [],
                liabilityForApBranchDetailsData: liabilityForApBranchDetailsData || [],
                liabilityForTaxesDetailsData: liabilityForTaxesDetailsData || []
            });
        });
    }

    pendingAgreementsRequest = params => {
        return new Promise(async resolve => {
            params.status = "Pending"
            params.sortField = "universityInstitutionName";
            params.sortOrder = "ascend"
            let response = await Request.getCommissionUniversities(params);
            this.setState({ pendingUniversityTotal: response.total })
            resolve(response)
        })
    }

    updateUniversityAgreement = async (data) => {
        let response = await Request.updateUniversityCommissionStatus(data);
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table1.current.reload();
    }

    openDrawer(title, data, bgColorClass, icon) {
        if (!data || !data.arr || data.arr.length === 0) {
            return;
        }

        this.setState({
            drawer: true,
            drawerParam: {
                title: title,
                arr: data.arr,
                count: data.total,
                bgColorClass: bgColorClass,
                icon: icon
            }
        });
    }

    showAgreementDrawer = (record) => {
        this.setState({ showPendingAgreementDrawer: true, pendingAgreementRecord: record })
    }

    closeAgreementDrawer = () => {
        this.setState({ pendingAgreementRecord: {}, showPendingAgreementDrawer: false }, () => {
            this.table1.current.reload()
        })
    }


    openInvoiceDrawer(title, data, bgColorClass, icon) {
        if (!data || !data.arr || data.arr.length === 0) {
            return;
        }

        this.setState({
            invoiceDrawer: true,
            invoiceDrawerParam: {
                title: title,
                arr: data.arr,
                count: data.total,
                bgColorClass: bgColorClass,
                icon: icon
            }
        });

    }


    openLiabilityDrawer(title, data, bgColorClass, icon) {
        if (!data || !data.arr || data.arr.length === 0) {
            return;
        }

        this.setState({
            liabilityDrawer: true,
            liabilityDrawerParam: {
                title: title,
                arr: data.arr,
                count: data.total,
                bgColorClass: bgColorClass,
                icon: icon
            }
        });
    }
    openBranchLiabilityDrawer(title, data, bgColorClass, icon) {
        if (!data || !data.arr || data.arr.length === 0) {
            return;
        }

        this.setState({
            branchLiabilityDrawer: true,
            branchLiabilityDrawerParam: {
                title: title,
                arr: data.arr,
                count: data.total,
                bgColorClass: bgColorClass,
                icon: icon
            }
        });
    }


    openPaymentDrawer(title, data, bgColorClass, icon) {
        if (!data || !data.arr || data.arr.length === 0) {
            return;
        }

        this.setState({
            paymentDrawer: true,
            paymentDrawerParam: {
                title: title,
                arr: data.arr,
                count: data.total,
                bgColorClass: bgColorClass,
                icon: icon
            }
        });
    }

    closeDrawer() {
        this.setState({
            drawer: false,
            drawerParam: {},
            invoiceDrawer: false,
            invoiceDrawerParam: {},
            paymentDrawer: false,
            paymentDrawerParam: {},
            liabilityDrawer: false,
            liabilityDrawerParam: {},
            branchLiabilityDrawer: false,
            branchLiabilityDrawerParam: {},
        });
    }


    componentDidMount() {
        this.loadApis();
    }

    render() {
        let { performaInvoicesDetailsData, performaInvoicesDueDetailsData, liabilityForTaxesDetailsData, liabilityForApBranchDetailsData, paymentReceivedDomesticData, paymentReceivedOverseasData, visaApprovedData, drawer, drawerParam, invoiceDrawer, invoiceDrawerParam, paymentDrawer, paymentDrawerParam, liabilityDrawer, liabilityDrawerParam, branchLiabilityDrawer, branchLiabilityDrawerParam } = this.state;
        const pendingUniversitiesColumns = [
            {
                title: 'Action',
                key: 'operation',
                fixed: 'left',
                width: 120,
                render: (text, record) => {
                    return (
                        <>
                            <Tooltip title="Approve University Agreement">
                                <Button size='small' shape='circle' icon='check' onClick={() => this.updateUniversityAgreement({ _id: record._id, status: 'Active' })}></Button>
                            </Tooltip>
                            <Tooltip title="Disapprove University Agreement">
                                <Button style={{ marginLeft: 5 }} size='small' shape='circle' icon='cross' onClick={() => this.updateUniversityAgreement({ _id: record._id, status: 'Inactive' })}></Button>
                            </Tooltip>
                        </>
                    )
                }
            },
            {
                title: 'University Name',
                key: 'universityInstitutionName',
                width: 200,
                fixed: 'left',
                searchTextName: 'universityInstitutionName',
                filterRegex: true
            },
            {
                title: 'Country',
                width: 80,
                key: 'universityId.universityCountryName',
                searchTextName: 'universityCity',
                dataIndex: 'universityId.universityCountryName',
            },
            {
                title: 'Partnership',
                key: 'universityPartnership',
                dataIndex: 'universityPartnership',
                sorter: true,
                width: 150
            },
            {
                title: 'Commission From University',
                key: 'commissionFromUniversity',
                dataIndex: 'commissionFromUniversity',
                sorter: true,
                width: 150,
                render: (text, record) => {
                    return (
                        `${record.commissionFromUniversity} ${record.commissionTypeFrom === "Percentage" ? ("%") : `(${record.commissionTypeFrom})`}`
                    )
                }
            },
            {
                title: 'Agreement',
                key: 'paymentUpload',
                width: 120,
                render: (text, record) => {
                    return (
                        <Button icon='eye' onClick={() => this.showAgreementDrawer(record)}></Button>
                    )
                }
            },
            {
                title: 'Category',
                key: 'universityCategory',
                dataIndex: 'universityCategory',
                sorter: true,
                // searchTextName: 'universityCategory',
                width: 150
            },
            {
                title: 'University Type',
                key: 'universityType',
                dataIndex: 'universityType',
                sorter: true,
                // searchTextName: 'universityCategory',
                width: 150
            },
            {
                title: 'Status',
                key: 'status',
                dataIndex: 'status',
                sorter: true,
                width: 150
            }
        ]
        return (
            <React.Fragment>

                {
                    this.state.showPendingAgreementDrawer ?
                        <ShowUniversityAgreement record={this.state.pendingAgreementRecord} onClose={this.closeAgreementDrawer} />
                        : null
                }

                {drawer && (
                    <ListDrawer
                        param={drawerParam}
                        onClose={this.closeDrawer}
                    />
                )}

                {
                    invoiceDrawer && (
                        <InvoiceListDrawer
                            param={invoiceDrawerParam}
                            onClose={this.closeDrawer}
                        />
                    )
                }
                {
                    paymentDrawer && (
                        <PaymentReceivedDrawer
                            param={paymentDrawerParam}
                            onClose={this.closeDrawer}
                        />
                    )
                }

                {
                    liabilityDrawer && (
                        <LiabilityDrawer
                            param={liabilityDrawerParam}
                            onClose={this.closeDrawer}
                        />
                    )
                }

                {
                    branchLiabilityDrawer && (
                        <BranchLiabilityDrawer
                            param={branchLiabilityDrawerParam}
                            onClose={this.closeDrawer}
                        />
                    )
                }

                <Row>
                    <Col span={8} style={{ padding: '10px' }}>
                        <Card
                            bodyStyle={{ padding: '16px' }}
                            bordered
                            className="elevation-1"
                        >
                            <IconHeader bgColor="#e6f7ff" iconColor="#1890ff">
                                <div className="icon-circle">
                                    <FaPlaneDeparture size={16} />
                                </div>
                                <span>Visa Approved</span>
                            </IconHeader>

                            <ScrollContainer>
                                <MetricTable>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '40%' }}>Country</th>
                                            <th><Tooltip title="Today">T</Tooltip></th>
                                            <th><Tooltip title="Week">W</Tooltip></th>
                                            <th><Tooltip title="Month">M</Tooltip></th>
                                            <th><Tooltip title="Financial Year">FY</Tooltip></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {visaApprovedData.length > 0 ? (
                                            visaApprovedData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.countryName}</td>

                                                    {/* TODAY */}
                                                    <td>
                                                        {item.today && item.today.total > 0 ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openDrawer(
                                                                        item.countryName + ' - Visa Approved (Today)',
                                                                        item.today,
                                                                        'bg-blue',
                                                                        <FaPlaneDeparture />
                                                                    )
                                                                }
                                                            >
                                                                {item.today.total}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* WEEK */}
                                                    <td>
                                                        {item.week && item.week.total > 0 ? (
                                                            <a
                                                                onClick={() =>
                                                                    this.openDrawer(
                                                                        item.countryName + ' - Visa Approved (This Week)',
                                                                        item.week,
                                                                        'bg-green',
                                                                        <FaPlaneDeparture />
                                                                    )
                                                                }
                                                            >
                                                                {item.week.total}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* MONTH */}
                                                    <td>
                                                        {item.month && item.month.total > 0 ? (
                                                            <a
                                                                onClick={() =>
                                                                    this.openDrawer(
                                                                        item.countryName + ' - Visa Approved (This Month)',
                                                                        item.month,
                                                                        'bg-orange',
                                                                        <FaPlaneDeparture />
                                                                    )
                                                                }
                                                            >
                                                                {item.month.total}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* FY */}
                                                    <td style={{ fontWeight: 'bold', color: '#1890ff' }}>
                                                        {item.fy && item.fy.total > 0 ? (
                                                            <a
                                                                onClick={() =>
                                                                    this.openDrawer(
                                                                        item.countryName + ' - Visa Approved (FY)',
                                                                        item.fy,
                                                                        'bg-purple',
                                                                        <FaPlaneDeparture />
                                                                    )
                                                                }
                                                            >
                                                                {item.fy.total}
                                                            </a>
                                                        ) : 0}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: 'center' }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </MetricTable>
                            </ScrollContainer>
                        </Card>
                    </Col>

                    {/* PI Generated */}
                    <Col span={8} style={{ padding: '10px' }}>
                        <Card
                            bodyStyle={{ padding: '16px' }}
                            bordered
                            className="elevation-1"
                        >
                            <IconHeader bgColor="#f9f0ff" iconColor="#722ed1">
                                <div className="icon-circle">
                                    <FaFileInvoice size={16} />
                                </div>
                                <span>PI Generated</span>
                            </IconHeader>

                            <ScrollContainer>
                                <MetricTable>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '40%' }}>Country</th>
                                            <th><Tooltip title="Today">T</Tooltip></th>
                                            <th><Tooltip title="Week">W</Tooltip></th>
                                            <th><Tooltip title="Month">M</Tooltip></th>
                                            <th><Tooltip title="Financial Year">FY</Tooltip></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {performaInvoicesDetailsData.length > 0 ? (
                                            performaInvoicesDetailsData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.countryName}</td>

                                                    {/* TODAY */}
                                                    <td>
                                                        {item.today && item.today.total > 0 ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openInvoiceDrawer(
                                                                        item.countryName + ' - PI Generated (Today)',
                                                                        item.today,
                                                                        'bg-blue',
                                                                        <FaFileInvoice />
                                                                    )
                                                                }
                                                            >
                                                                {item.today.total}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* WEEK */}
                                                    <td>
                                                        {item.week && item.week.total > 0 ? (
                                                            <a
                                                                onClick={() =>
                                                                    this.openInvoiceDrawer(
                                                                        item.countryName + ' - PI Generated (This Week)',
                                                                        item.week,
                                                                        'bg-green',
                                                                        <FaFileInvoice />
                                                                    )
                                                                }
                                                            >
                                                                {item.week.total}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* MONTH */}
                                                    <td>
                                                        {item.month && item.month.total > 0 ? (
                                                            <a
                                                                onClick={() =>
                                                                    this.openInvoiceDrawer(
                                                                        item.countryName + ' - PI Generated (This Month)',
                                                                        item.month,
                                                                        'bg-orange',
                                                                        <FaFileInvoice />
                                                                    )
                                                                }
                                                            >
                                                                {item.month.total}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* FY */}
                                                    <td style={{ fontWeight: 'bold', color: '#1890ff' }}>
                                                        {item.fy && item.fy.total > 0 ? (
                                                            <a
                                                                onClick={() =>
                                                                    this.openInvoiceDrawer(
                                                                        item.countryName + ' - PI Generated (FY)',
                                                                        item.fy,
                                                                        'bg-purple',
                                                                        <FaFileInvoice />
                                                                    )
                                                                }
                                                            >
                                                                {item.fy.total}
                                                            </a>
                                                        ) : 0}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: 'center' }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </MetricTable>
                            </ScrollContainer>
                        </Card>
                    </Col>

                    {/* PI Due */}
                    <Col span={8} style={{ padding: '10px' }}>
                        <Card
                            bodyStyle={{ padding: '16px' }}
                            bordered
                            className="elevation-1"
                        >
                            <IconHeader bgColor="#fff1f0" iconColor="#f5222d">
                                <div className="icon-circle">
                                    <FaFileInvoiceDollar size={16} />
                                </div>
                                <span>PI Due</span>
                            </IconHeader>

                            <ScrollContainer>
                                <MetricTable>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '40%' }}>Country</th>
                                            <th><Tooltip title="Today">T</Tooltip></th>
                                            <th><Tooltip title="Week">W</Tooltip></th>
                                            <th><Tooltip title="Month">M</Tooltip></th>
                                            <th><Tooltip title="Financial Year">FY</Tooltip></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {performaInvoicesDueDetailsData.length > 0 ? (
                                            performaInvoicesDueDetailsData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.countryName}</td>

                                                    {/* TODAY */}
                                                    <td>
                                                        {item.today && item.today.total > 0 ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openInvoiceDrawer(
                                                                        item.countryName + ' - PI Due (Today)',
                                                                        item.today,
                                                                        'bg-blue',
                                                                        <FaFileInvoiceDollar />
                                                                    )
                                                                }
                                                            >
                                                                {item.today.total}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* WEEK */}
                                                    <td>
                                                        {item.week && item.week.total > 0 ? (
                                                            <a
                                                                onClick={() =>
                                                                    this.openInvoiceDrawer(
                                                                        item.countryName + ' - PI Due (This Week)',
                                                                        item.week,
                                                                        'bg-green',
                                                                        <FaFileInvoiceDollar />
                                                                    )
                                                                }
                                                            >
                                                                {item.week.total}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* MONTH */}
                                                    <td>
                                                        {item.month && item.month.total > 0 ? (
                                                            <a
                                                                onClick={() =>
                                                                    this.openInvoiceDrawer(
                                                                        item.countryName + ' - PI Due (This Month)',
                                                                        item.month,
                                                                        'bg-orange',
                                                                        <FaFileInvoiceDollar />
                                                                    )
                                                                }
                                                            >
                                                                {item.month.total}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* FY */}
                                                    <td style={{ fontWeight: 'bold', color: '#1890ff' }}>
                                                        {item.fy && item.fy.total > 0 ? (
                                                            <a
                                                                onClick={() =>
                                                                    this.openInvoiceDrawer(
                                                                        item.countryName + ' - PI Due (FY)',
                                                                        item.fy,
                                                                        'bg-purple',
                                                                        <FaFileInvoiceDollar />
                                                                    )
                                                                }
                                                            >
                                                                {item.fy.total}
                                                            </a>
                                                        ) : 0}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: 'center' }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </MetricTable>
                            </ScrollContainer>
                        </Card>
                    </Col>

                </Row>
                <Row>
                    {/* Payment Received From OverSeaas */}
                    <Col span={8} style={{ padding: '10px' }}>
                        <Card
                            bodyStyle={{ padding: '16px' }}
                            bordered
                            className="elevation-1"
                        >
                            <IconHeader bgColor="#fffbe6" iconColor="#faad14">
                                <div className="icon-circle">
                                    <FaGlobeAmericas size={16} />
                                </div>
                                <span>Payment Received From Overseas</span>
                            </IconHeader>

                            <ScrollContainer>
                                <MetricTable>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '40%' }}>Currency</th>
                                            <th><Tooltip title="Today">T</Tooltip></th>
                                            <th><Tooltip title="Week">W</Tooltip></th>
                                            <th><Tooltip title="Month">M</Tooltip></th>
                                            <th><Tooltip title="Financial Year">FY</Tooltip></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paymentReceivedOverseasData.length > 0 ? (
                                            paymentReceivedOverseasData.map((item, index) => {
                                                const symbol = currencySymbols[item.currencyName] || item.currencyName;
                                                return (
                                                    <tr key={index}>
                                                        <td>{item.currencyName}</td>

                                                        {/* TODAY */}
                                                        <td>
                                                            {item.today && item.today.total > 0 ? (
                                                                <a
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() =>
                                                                        this.openPaymentDrawer(
                                                                            item.currencyName + ' - Payment Received Overseas (Today)',
                                                                            item.today,
                                                                            'bg-blue',
                                                                            <FaGlobeAmericas />
                                                                        )
                                                                    }
                                                                >
                                                                    {item.today.arr.length}
                                                                </a>
                                                            ) : 0}
                                                        </td>

                                                        {/* WEEK */}
                                                        <td>
                                                            {item.week && item.week.total > 0 ? (
                                                                <a
                                                                    onClick={() =>
                                                                        this.openPaymentDrawer(
                                                                            item.currencyName + ' - Payment Received Overseas (This Week)',
                                                                            item.week,
                                                                            'bg-green',
                                                                            <FaGlobeAmericas />
                                                                        )
                                                                    }
                                                                >
                                                                    {item.week.arr.length}
                                                                </a>
                                                            ) : 0}
                                                        </td>

                                                        {/* MONTH */}
                                                        <td>
                                                            {item.month && item.month.total > 0 ? (
                                                                <a
                                                                    onClick={() =>
                                                                        this.openPaymentDrawer(
                                                                            item.currencyName + ' - Payment Received Overseas (This Month)',
                                                                            item.month,
                                                                            'bg-orange',
                                                                            <FaGlobeAmericas />
                                                                        )
                                                                    }
                                                                >
                                                                    {item.month.arr.length}
                                                                </a>
                                                            ) : 0}
                                                        </td>

                                                        {/* FY */}
                                                        <td style={{ fontWeight: 'bold', color: '#1890ff' }}>
                                                            {item.fy && item.fy.total > 0 ? (
                                                                <a
                                                                    onClick={() =>
                                                                        this.openPaymentDrawer(
                                                                            item.currencyName + ' - Payment Received Overseas (FY)',
                                                                            item.fy,
                                                                            'bg-purple',
                                                                            <FaGlobeAmericas />
                                                                        )
                                                                    }
                                                                >
                                                                    {item.fy.arr.length}
                                                                </a>
                                                            ) : 0}
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: 'center' }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </MetricTable>
                            </ScrollContainer>
                        </Card>
                    </Col>
                    <Col span={8} style={{ padding: '10px' }}>
                        <Card
                            bodyStyle={{ padding: '16px' }}
                            bordered
                            className="elevation-1"
                        >
                            <IconHeader bgColor="#f6ffed" iconColor="#52c41a">
                                <div className="icon-circle">
                                    <FaWallet size={16} />
                                </div>
                                <span>Payment Received Domestic</span>
                            </IconHeader>

                            <ScrollContainer>
                                <MetricTable>
                                    <thead>
                                        <tr>
                                            <th><Tooltip title="Currency">Currency</Tooltip></th>
                                            <th><Tooltip title="Today">T</Tooltip></th>
                                            <th><Tooltip title="Week">W</Tooltip></th>
                                            <th><Tooltip title="Month">M</Tooltip></th>
                                            <th><Tooltip title="Financial Year">FY</Tooltip></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {paymentReceivedDomesticData ? (() => {

                                            const data = paymentReceivedDomesticData;

                                            const currencySymbol =
                                                currencySymbols && currencySymbols[data.currencyName]
                                                    ? currencySymbols[data.currencyName]
                                                    : data.currencyName;

                                            // Extract country safely

                                            return (
                                                <tr>
                                                    <td>{data.currencyName}</td>
                                                    {/* TODAY */}
                                                    <td>
                                                        {data.today && data.today.total > 0 ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openPaymentDrawer(
                                                                        'Payment Received Domestic (Today)',
                                                                        data.today,
                                                                        'bg-blue',
                                                                        <FaWallet />
                                                                    )
                                                                }
                                                            >
                                                                {data.today.arr.length}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* WEEK */}
                                                    <td>
                                                        {data.week && data.week.total > 0 ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openPaymentDrawer(
                                                                        ' Payment Received Domestic (This Week)',
                                                                        data.week,
                                                                        'bg-green',
                                                                        <FaWallet />
                                                                    )
                                                                }
                                                            >
                                                                {data.week.arr.length}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* MONTH */}
                                                    <td>
                                                        {data.month && data.month.total > 0 ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openPaymentDrawer(
                                                                        'Payment Received Domestic (This Month)',
                                                                        data.month,
                                                                        'bg-orange',
                                                                        <FaWallet />
                                                                    )
                                                                }
                                                            >
                                                                {data.month.arr.length}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* FY */}
                                                    <td style={{ fontWeight: 'bold', color: '#1890ff' }}>
                                                        {data.fy && data.fy.total > 0 ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openPaymentDrawer(
                                                                        'Payment Received Domestic (FY)',
                                                                        data.fy,
                                                                        'bg-purple',
                                                                        <FaWallet />
                                                                    )
                                                                }
                                                            >
                                                                {data.fy.arr.length}
                                                            </a>
                                                        ) : 0}
                                                    </td>
                                                </tr>
                                            );

                                        })() : (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: 'center' }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </MetricTable>
                            </ScrollContainer>
                        </Card>
                    </Col>
                    <Col span={8} style={{ padding: '10px' }}>
                        <Card
                            bodyStyle={{ padding: '16px' }}
                            bordered
                            className="elevation-1"
                        >
                            <IconHeader bgColor="#f6ffed" iconColor="#52c41a">
                                <div className="icon-circle">
                                    <FaWallet size={16} />
                                </div>
                                <span>Liability of Taxes</span>
                            </IconHeader>

                            <ScrollContainer>
                                <MetricTable>
                                    <thead>
                                        <tr>
                                            <th><Tooltip title="Currency">Currency</Tooltip></th>
                                            <th><Tooltip title="Today">T</Tooltip></th>
                                            <th><Tooltip title="Week">W</Tooltip></th>
                                            <th><Tooltip title="Month">M</Tooltip></th>
                                            <th><Tooltip title="Financial Year">FY</Tooltip></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {liabilityForTaxesDetailsData ? (() => {

                                            const data = liabilityForTaxesDetailsData;

                                            const currencySymbol =
                                                currencySymbols && currencySymbols[data.currencyName]
                                                    ? currencySymbols[data.currencyName]
                                                    : data.currencyName;

                                            // Extract country safely

                                            return (
                                                <tr>
                                                    <td>{data.currencyName}</td>
                                                    {/* TODAY */}
                                                    <td>
                                                        {data.today && data.today.total > 0 ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openPaymentDrawer(
                                                                        'Tax Liability (Today)',
                                                                        data.today,
                                                                        'bg-blue',
                                                                        <FaWallet />
                                                                    )
                                                                }
                                                            >
                                                                {data.today.arr.length}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* WEEK */}
                                                    <td>
                                                        {data.week && data.week.total > 0 ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openPaymentDrawer(
                                                                        ' Tax Liability (This Week)',
                                                                        data.week,
                                                                        'bg-green',
                                                                        <FaWallet />
                                                                    )
                                                                }
                                                            >
                                                                {data.week.arr.length}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* MONTH */}
                                                    <td>
                                                        {data.month && data.month.total > 0 ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openPaymentDrawer(
                                                                        'Tax Liability (This Month)',
                                                                        data.month,
                                                                        'bg-orange',
                                                                        <FaWallet />
                                                                    )
                                                                }
                                                            >
                                                                {data.month.arr.length}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* FY */}
                                                    <td style={{ fontWeight: 'bold', color: '#1890ff' }}>
                                                        {data.fy && data.fy.total > 0 ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openPaymentDrawer(
                                                                        'Tax Liability (FY)',
                                                                        data.fy,
                                                                        'bg-purple',
                                                                        <FaWallet />
                                                                    )
                                                                }
                                                            >
                                                                {data.fy.arr.length}
                                                            </a>
                                                        ) : 0}
                                                    </td>
                                                </tr>
                                            );

                                        })() : (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: 'center' }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </MetricTable>
                            </ScrollContainer>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col span={8} style={{ padding: '10px' }}>
                        <Card
                            bodyStyle={{ padding: '16px' }}
                            bordered
                            className="elevation-1"
                        >
                            <IconHeader bgColor="#fff7e6" iconColor="#fa8c16">
                                <div className="icon-circle">
                                    <FaUniversity size={16} />
                                </div>
                                <span>Pending Payouts Of AP\Branch</span>
                            </IconHeader>

                            <ScrollContainer>
                                <MetricTable>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '40%' }}>Currency</th>
                                            <th><Tooltip title="Today">T</Tooltip></th>
                                            <th><Tooltip title="Week">W</Tooltip></th>
                                            <th><Tooltip title="Month">M</Tooltip></th>
                                            <th><Tooltip title="Financial Year">FY</Tooltip></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {liabilityForApBranchDetailsData.length > 0 ? (
                                            liabilityForApBranchDetailsData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.currencyName}</td>

                                                    {/* TODAY */}
                                                    <td>
                                                        {item.today && item.today.total > 0 ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openBranchLiabilityDrawer(
                                                                        'Pending Payouts of Ap\Branch (Today)',
                                                                        item.today,
                                                                        'bg-blue',
                                                                        <FaUniversity />
                                                                    )
                                                                }
                                                            >
                                                                {item.today.arr.length}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* WEEK */}
                                                    <td>
                                                        {item.week && item.week.total > 0 ? (
                                                            <a
                                                                onClick={() =>
                                                                    this.openBranchLiabilityDrawer(
                                                                        'Pending Payouts of Ap\Branch (This Week)',
                                                                        item.week,
                                                                        'bg-green',
                                                                        <FaUniversity />
                                                                    )
                                                                }
                                                            >
                                                                {item.week.arr.length}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* MONTH */}
                                                    <td>
                                                        {item.month && item.month.total > 0 ? (
                                                            <a
                                                                onClick={() =>
                                                                    this.openBranchLiabilityDrawer(
                                                                        'Pending Payouts of Ap\Branch (This Month)',
                                                                        item.month,
                                                                        'bg-orange',
                                                                        <FaUniversity />
                                                                    )
                                                                }
                                                            >
                                                                {item.month.arr.length}
                                                            </a>
                                                        ) : 0}
                                                    </td>

                                                    {/* FY */}
                                                    <td style={{ fontWeight: 'bold', color: '#1890ff' }}>
                                                        {item.fy && item.fy.total > 0 ? (
                                                            <a
                                                                onClick={() =>
                                                                    this.openBranchLiabilityDrawer(
                                                                        'Pending Payouts of Ap\Branch (FY)',
                                                                        item.fy,
                                                                        'bg-purple',
                                                                        <FaUniversity />
                                                                    )
                                                                }
                                                            >
                                                                {item.fy.arr.length}
                                                            </a>
                                                        ) : 0}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: 'center' }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </MetricTable>
                            </ScrollContainer>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    {/* <Card title={`Pending University Commission Approval: ${this.state.pendingUniversityTotal}`} style={{ marginBottom: 10 }} bordered={true}>
                        <TableComp
                            ref={this.table1}
                            columns={pendingUniversitiesColumns}
                            apiRequest={this.pendingAgreementsRequest}
                            extraProps={{ scroll: { x: 1400 } }}
                            pagination={{
                                showSizeChanger: true,
                                defaultPageSize: '20',
                                pageSizeOptions: ['10', '20', '50', '100', '1000']
                            }}
                        />
                    </Card> */}
                </Row>
            </React.Fragment>
        );
    }
}


const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapDispatchToProps)
    (ClaimCommissionDashboard)